import React from 'react'
import { Link } from "react-router-dom";
import { Heading1, Paragraph1, Button1, Button3 } from "../../../components/Ui";
import { LandingPageTestimonial, FaqSection, IdealCustomers } from "../../../components/Ui/UiComponents";
import images from "../../../Utilities/index";



export default function FacebookTools() {
    let FacebokScraper = [
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
        { link: "/", name: "Scrape Facebook Posts" },
    ]
    let DiscoverFb = [
        { img: images.fb_1, title: "Cold Email Outreach", des: "To Millions Of Small And Medium Businesses" },
        { img: images.fb_2, title: "Lookalike Audience Targeting", des: "From Google Ads Or Facebook" },
        { img: images.fb_3, title: "Promoting The Product", des: "And Getting Feedback" },
    ]
    let Advantagesfb = [
        { img: <images.IoIosMail />, title: "Maintain A Bounce Rate Under 3%" },
        { img: <images.IoIosMailOpen />, title: "Protect Your Emails From Being Blocked" },
        { img: <images.IoIosMail />, title: "Achieve Higher Response Rates" },
        { img: <images.IoIosMailOpen />, title: "No Code, No Plugins, No Cache Needed" },
    ]
    return (
        <>
            <section
                style={{
                    background: `url(${images.bannerBg}) center top/cover no-repeat`, // Moves focus to the top
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        paddingTop: "130px",
                        paddingBottom: "96px",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <div style={{ textAlign: "center" }}>
                        <Heading1 heading1="Facebook Fanpage Extractor" />
                    </div>
                    <div style={{ textAlign: "center", width: "75%" }}>
                        <Paragraph1 para1="Integrate Leadbud data effortlessly into your marketing and sales strategies for a lead boost. Elevate campaigns and achieve superior conversions with seamless data utilization." />
                    </div>
                    <Link to="/">
                        <Button1 btn1="Try it Now" />
                    </Link>
                    <ul
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "12px",
                            justifyContent: "center",
                            listStyle: "none",
                            padding: 0,
                        }}
                    >
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "400",
                                gap: "4px",
                            }}
                        >
                            <images.HiMiniCheckBadge /> Real-time email verifications
                        </li>
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "400",
                                gap: "4px",
                            }}
                        >
                            <images.HiMiniCheckBadge /> More than 15 filtering options
                        </li>
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "400",
                                gap: "4px",
                            }}
                        >
                            <images.HiMiniCheckBadge /> New Load Alerts
                        </li>
                    </ul>
                </div>
            </section>

            <div
                style={{
                    width: "75%",
                    maxWidth: "1200px", // Adjust as needed
                    margin: "auto",
                    paddingTop: "40px",
                    marginTop: "-120px",
                    "@media (min-width: 768px)": {
                        marginTop: "-150px",
                    },
                }}
            >
                <img src={images.FacebookImg} alt="my-img" style={{ width: "100%" }} />
            </div>

            {/* Facebook post */}
            <section
                style={{
                    maxWidth: "1200px",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                    marginTop: "40px",
                    marginBottom: "40px",
                }}
            >
                {/* Left Side - Text Content */}
                <div
                    style={{
                        flex: "1",
                        padding: "40px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        justifyContent: "center",
                    }}
                >
                    <Heading1 heading1="Facebook Post Extractor" />
                    <Paragraph1 para1="Integrate Leadbud Data Effortlessly Into Your Marketing And Sales Strategies For A Lead Boost. Elevate Campaigns And Achieve Superior Conversions With Seamless Data Utilization. Harness Leadbud Insights For Impactful Marketing. Drive Conversions By Leveraging Data Seamlessly. Discover A New Era Of Simplicity And Productivity." />
                    <Link to="/" style={{ marginRight: "auto" }}>
                        <Button3 btn3="Start to Free" />
                    </Link>
                </div>

                {/* Right Side - Image */}
                <div
                    style={{
                        flex: "1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img src={images.Fbpost} alt="my-img" style={{ display: "block", maxWidth: "100%" }} />
                </div>
            </section>
            {/* Facebook group */}
            <section style={{ backgroundColor: "#F5F5F5", padding: "40px 0" }}>
                <div
                    style={{
                        maxWidth: "1200px",
                        margin: "auto",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "20px",
                    }}
                >
                    {/* Left Side - Image */}
                    <div style={{ flex: "1", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img src={images.Fbgroup} alt="my-img" style={{ display: "block", maxWidth: "100%" }} />
                    </div>

                    {/* Right Side - Text Content */}
                    <div
                        style={{
                            flex: "1",
                            padding: "40px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            justifyContent: "center",
                        }}
                    >
                        <Heading1 heading1="Facebook Group Extractor" />
                        <Paragraph1 para1="Integrate Leadbud Data Effortlessly Into Your Marketing And Sales Strategies For A Lead Boost. Elevate Campaigns And Achieve Superior Conversions With Seamless Data Utilization. Harness Leadbud Insights For Impactful Marketing. Drive Conversions By Leveraging Data Seamlessly. Discover A New Era Of Simplicity And Productivity." />
                        <Link to="/" style={{ marginRight: "auto" }}>
                            <Button3 btn3="Start to Free" />
                        </Link>
                    </div>
                </div>
            </section>

            {/* Facebook UID */}
            <section style={{ maxWidth: "1200px", margin: "auto", display: "flex", flexDirection: "row", alignItems: "center", gap: "20px", marginTop: "40px", marginBottom: "40px" }}>

                {/* Left Side - Text Content */}
                <div style={{ flex: "1", padding: "40px", display: "flex", flexDirection: "column", gap: "12px", justifyContent: "center" }}>
                    <Heading1 heading1="Facebook UID Converter" />
                    <Paragraph1 para1="Integrate Muzzleads Data Effortlessly Into Your Marketing And Sales Strategies For A Lead Boost. Elevate Campaigns And Achieve Superior Conversions With Seamless Data Utilization. Harness Muzzleads Insights For Impactful Marketing. Drive Conversions By Leveraging Data Seamlessly. Discover A New Era Of Simplicity And Productivity." />
                    <Link to="/" style={{ marginRight: "auto" }}>
                        <Button3 btn3="Start to Free" />
                    </Link>
                </div>

                {/* Right Side - Image */}
                <div style={{ flex: "1", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img src={images.Fbuid} alt="my-img" style={{ display: "block", maxWidth: "100%" }} />
                </div>

            </section>
            {/* Facebook Page Extractor */}
            <section style={{ backgroundColor: "#F5F5F5", padding: "40px 0" }}>
                <div
                    style={{
                        maxWidth: "1200px",
                        margin: "auto",
                        display: "flex",
                        flexDirection: "row",
                        gap: "12px",
                    }}
                >
                    {/* Left Side - Image */}
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                        }}
                    >
                        <img
                            src={images.Fbextrapage}
                            alt="my-img"
                            style={{ maxWidth: "100%", display: "block" }}
                        />
                    </div>

                    {/* Right Side - Text Content */}
                    <div
                        style={{
                            width: "100%",
                            padding: "40px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            justifyContent: "center",
                        }}
                    >
                        <Heading1 heading1="Facebook Page Extractor" />
                        <Paragraph1 para1="Integrate Muzzleads Data Effortlessly Into Your Marketing And Sales Strategies For A Lead Boost. Elevate Campaigns And Achieve Superior Conversions With Seamless Data Utilization. Harness Muzzleads Insights For Impactful Marketing. Drive Conversions By Leveraging Data Seamlessly. Discover A New Era Of Simplicity And Productivity." />
                        <Link to="/" style={{ marginRight: "auto" }}>
                            <Button3 btn3="Start for Free" />
                        </Link>
                    </div>
                </div>
            </section>
            {/* Uses Cases*/}
            <section style={{ backgroundColor: "rgb(86, 244, 68)", padding: "40px 0" }}>
                <div
                    style={{
                        backgroundImage: `url(${images.scraperfb})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        maxWidth: "1200px",
                        margin: "auto",
                        padding: "40px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                    }}
                >
                    {/* Heading */}
                    <div style={{ textAlign: "center" }}>
                        <Heading1 heading1="Facebook Scraper Use Cases" />
                    </div>

                    {/* Grid Layout - 4 Columns */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)", // Always 4 columns
                            gap: "16px",
                            margin: "auto",
                        }}
                    >
                        {FacebokScraper.map((val, id) => (
                            <Link
                                to={val.link}
                                key={id}
                                style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.12)",
                                    textAlign: "center",
                                    padding: "16px",
                                    borderRadius: "8px",
                                    color: "black",
                                    textDecoration: "none",
                                    display: "block",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                }}
                            >
                                {val.name}
                            </Link>
                        ))}
                    </div>

                    {/* Button */}
                    <Link to="/" style={{ margin: "20px auto", display: "block", textAlign: "center" }}>
                        <Button1 btn1="Start Now" />
                    </Link>
                </div>
            </section>

            {/* Discover Facebook */}
            <section style={{ maxWidth: "1200px", margin: "64px auto", padding: "0 20px" }}>
                {/* Heading */}
                <div
                    style={{
                        maxWidth: "50%",
                        textAlign: "center",
                        margin: "auto",
                        lineHeight: "1.5",
                    }}
                >
                    <Heading1 heading1="Discover And Close Your Next Customer" />
                </div>

                {/* Grid Layout */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                        gap: "16px",
                        marginTop: "24px",
                    }}
                >
                    {DiscoverFb.map((val, id) => (
                        <div
                            key={id}
                            style={{
                                textAlign: "center",
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                                padding: "20px",
                                marginTop: "16px",
                            }}
                        >
                            {/* Image */}
                            <img
                                src={val.img}
                                alt="my-img"
                                style={{
                                    margin: "auto",
                                    height: "96px",
                                    width: "96px",
                                }}
                            />

                            {/* Title */}
                            <h4 style={{ fontSize: "18px", fontWeight: "500" }}>{val.title}</h4>

                            {/* Description */}
                            <p style={{ fontSize: "14px", color: "#555" }}>{val.des}</p>
                        </div>
                    ))}
                </div>
            </section>

            <div style={{ paddingBottom: 0, marginTop: "25px" }}>
                <LandingPageTestimonial />
            </div>
            <div style={{ paddingBottom: 0, marginTop: "25px" }}>
                <FaqSection toolName={"EmailVerifier"} />
            </div>
            <div style={{ paddingBottom: 0 }}>
                <IdealCustomers />
            </div>
        </>

    )
}
